export default {
    SET_ENTERPRISE_MANNING_VESSELS(state, payload) {
        state.enterpriseManningVessels = payload;
    },
    SET_ENTERPRISE_ONBOARDING_CREWS(state, payload) {
        state.enterpriseOnboardingCrews = payload;
    },
    SET_ENTERPRISE_ASHORE_CREWS(state, payload) {
        state.enterpriseAshoreCrews = payload;
    },
    SET_ENTERPRISE_CREWS_ROLES(state, payload) {
        state.enterpriseCrewsRoles = payload;
    },
    SET_ENTERPRISE_MANNING_VESSEL_ALERTS(state, payload) {
    state.enterpriseManningVesselAlerts = payload;
    },
    SET_ENTERPRISE_CREWS_ALERTS(state, payload) {
      state.enterpriseCrewsAlerts = payload;
    },
    SET_ENTERPRISE_CREW_ALERT_SETTINGS(state, payload) {
        state.enterpriseCrewAlertSettings = payload;
    }
}
